import styled from 'styled-components';

export const ContainerTable = styled.div`
  .rdt_Table {
    border-radius: 0.2rem;
  }

  .rdt_TableHeadRow {
    color: ${(props) => props.theme.$gray700};
    background-color: ${(props) => props.theme.$gray200};
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 0.2rem 0.2rem 0 0;

    div {
      color: ${(props) => props.theme.$gray700};
      white-space: inherit;
      font-size: 14px;
    }
  }

  .rdt_TableRow {
    border: 1px solid ${(props) => props.theme.$gray300};
    border-top: 0;

    &:last-child {
      border-radius: 0 0 0.2rem 0.2rem;
    }
  }

  .rdt_TableCol:nth-of-type(5) {
    text-align: center;
  }

  .rdt_TableCell {
    padding: 10px 15px 10px 15px;
  }
`;
